import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
export function TwoPathsSection() {
  const pathA = ['Ladridos que no paran', 'Vecinos molestos y quejas constantes', 'Sillones y muebles rotos', 'Frustración y culpa diaria', 'Noches sin dormir'];
  const pathB = ['Un perro equilibrado y en paz', 'Tardes tranquilas en el sillón', 'Vecinos que te felicitan', 'El orgullo de ser un dueño responsable', 'Noches completas de descanso'];
  return <section className="py-24 px-5 max-w-6xl mx-auto pt-[0px] pb-[0px] space-y-[0px]" data-id="element-330">
      <FadeInUp data-id="element-331">
        <div className="text-center mb-16" data-id="element-332">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-dark mb-4" data-id="element-333">
            Dos Caminos. Una Decisión.
          </h2>
          <p className="text-lg text-slate-dark/70" data-id="element-334">
            El futuro de tu tranquilidad y la de tu perro depende de lo que
            elijas hoy.
          </p>
        </div>
      </FadeInUp>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-335">
        {/* Ruta A */}
        <FadeInUp delay={0.1} data-id="element-336">
          <div className="bg-red-50 border-2 border-red-100 rounded-3xl p-8 h-full pt-[20px] pb-[20px] space-y-[20px]" data-id="element-337">
            <div className="text-center mb-8" data-id="element-338">
              <span className="inline-block bg-red-100 text-red-800 font-bold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-339">
                RUTA A: SEGUIR IGUAL
              </span>
            </div>
            <ul className="space-y-5" data-id="element-340">
              {pathA.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-341">
                  <XCircleIcon className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-342" />
                  <span className="text-slate-dark/80 font-medium" data-id="element-343">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeInUp>

        {/* Ruta B */}
        <FadeInUp delay={0.2} data-id="element-344">
          <div className="bg-green-50 border-2 border-pistachio rounded-3xl p-8 h-full relative overflow-hidden" data-id="element-345">
            <div className="absolute top-0 right-0 w-32 h-32 bg-pistachio/20 rounded-bl-full -z-10" data-id="element-346"></div>
            <div className="text-center mb-8" data-id="element-347">
              <span className="inline-block bg-pistachio text-slate-dark font-bold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-348">
                RUTA B: PROTOCOLO DE CALMA
              </span>
            </div>
            <ul className="space-y-5" data-id="element-349">
              {pathB.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-350">
                  <CheckCircle2Icon className="w-6 h-6 text-green-600 shrink-0 mt-0.5" data-id="element-351" />
                  <span className="text-slate-dark font-bold" data-id="element-352">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeInUp>
      </div>
    </section>;
}